export default __webpack_public_path__ + "static/media/drain-black.f8335ce1.svg";